/**
 * ScrollSpy for in-page sidebar navigation
 * Highlights the current sidebar link (.is-active) based on scroll position
 * With help from AI generated, Javascript is needed because backend active state
 * does not work on ScrollNavigations.
 * @param {string} selector - The CSS selector for the sidebar navigation. Default is '.sidebar-nav'.
 * @returns {void}
 */
export function initSidebarScrollSpy(selector = ".sidebar-nav") {
	const root = document.querySelector(selector);
	if (!root) return;

	const links = [...root.querySelectorAll('.sidebar-link[href^="#"]')];
	const sections = links
		.map((a) => {
			const id = a.getAttribute("href");
			const el = document.querySelector(id);
			return el ? { id, el, a } : null;
		})
		.filter(Boolean);

	links.forEach((link) => {
		link.addEventListener("click", (e) => {
			e.preventDefault();
			const targetId = link.getAttribute("href");
			const targetElement = document.querySelector(targetId);
			if (targetElement) {
				targetElement.scrollIntoView({
					behavior: "smooth",
					block: "start",
				});

				history.pushState(null, null, targetId);
			}
		});
	});

	const setActive = (id) => {
		links.forEach((l) => {
			l.classList.remove("is-active");
			l.closest("li")?.classList.remove("is-active");
		});

		const hit = sections.find((s) => s.id === id);
		if (hit) {
			hit.a.classList.add("is-active");
			hit.a.closest("li")?.classList.add("is-active");
		}
	};

	window.addEventListener("hashchange", () => setActive(location.hash));
	if (location.hash) setActive(location.hash);

	const io = new IntersectionObserver(
		(entries) => {
			const vis = entries
				.filter((e) => e.isIntersecting)
				.sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
			if (vis) setActive("#" + vis.target.id);
		},
		{ rootMargin: "0px 0px -60% 0px", threshold: [0.1, 0.25, 0.5, 0.75] },
	);

	sections.forEach((s) => io.observe(s.el));
}
